/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aichatclose2Inputs */

const en_aichatclose2 = /** @type {(inputs: Aichatclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const de_aichatclose2 = /** @type {(inputs: Aichatclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Aichatclose2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aichatclose2 = /** @type {((inputs?: Aichatclose2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aichatclose2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aichatclose2(inputs)
	return de_aichatclose2(inputs)
});
export { aichatclose2 as "aiChatClose" }